import { render, staticRenderFns } from "./facility-manage.vue?vue&type=template&id=20520e39&scoped=true"
import script from "./facility-manage.vue?vue&type=script&lang=ts"
export * from "./facility-manage.vue?vue&type=script&lang=ts"
import style0 from "./facility-manage.vue?vue&type=style&index=0&id=20520e39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20520e39",
  null
  
)

export default component.exports